//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'medicalLiability',
  data(){
    return {
      medicaly:'',
      insurFlag : 'yz_insure',
      Imgsrc:'https://static.soyoung.com/sy-pre/zy-1592287800720.png',
      list:[
        {title:'发起维权',content:'医美消费者联系机构申请维权'},
        {title:'机构报案',content:'机构向保险公司报案'},
        {title:'专业机构评估',content:'委托专业评估机构对消费者损害程度进行评估'},
        {title:'出具评估结果',content:'评估机构出具评估结果'},
        {title:'获得赔款',content:'保险公司理赔，消费者获得赔款'},
      ],
      xzlist:[
        {title:'发起维权',content:'医美消费者联系机构申请维权'},
        {title:'机构报案',content:'机构向理赔对接人报案'},
        {title:'专业机构评估',content:'委托专业评估机构对消费者损害程度进行评估'},
        {title:'出具评估结果',content:'评估机构出具评估结果'},
        {title:'获得赔款',content:'保险公司理赔，消费者获得赔款'},
      ]
    }
  },
  created() {
  },
  mounted() {
    this.medicaly = this.$route.query.kind
    if(this.medicaly == 'effect'){
      window.document.title = '效果保障'
      this.Imgsrc = 'https://static.soyoung.com/sy-pre/xg-1604905800713.png'
      this.insurFlag = 'xz_insure'
      this.list = this.xzlist
    }
    // 禁用分享
      this.AppSetTitleBar('安心美',[]);
  },
  methods: {
   pdfClick() {
     this.$router.push({
        path: "/pdf",
        query:{
            insurFlag:this.insurFlag,
            pdfFlag:'notice',
            flag : 'postdisable'

        }
    });
   }
  }
}
